export const OPEN_CHAT_TAGS = {
  OPEN_CHAT_TAG: "OpenChat",
  OPEN_CHAT_CONVERSATION_TAG: "OpenChatConversation",
};
